import React, { type JSX } from 'react';
import { Row } from '@harmony/enablers/components/data-grid/data-grid';
import { EUserNotificationType, TUserNotification } from '../../ducks/api-ducks/user-notifications-duck/types-user-notifications';
import RichTextRender from '../../shared-components/rich-text-editor/rich-text-render';

export const userNotificationRowFormatter = (row: Row<TUserNotification>): JSX.Element => (
  <React.Fragment key={`Row-${row.id}`}>
    <div slot={`notification-${row.id}`} key={`notification-${row.id}`} style={{ display: 'flex', gap: '4px' }}>
      {row.customData?.notificationType === EUserNotificationType.ActionCenter ? (
        <span>{row.customData?.message || ''}</span>
      ) : (
        <RichTextRender delta={row.customData?.richMessage || ''} />
      )}
    </div>
  </React.Fragment>
);
